export interface TGeneralActivity {
  asking_discount?: number
  asking_price: number
  asking_price_per_carat?: number
  category_id: number
  company_id: number
  company_title: string
  consignor_name: string
  consignor_payout_amount: number
  cost: string
  count_of_bids: number
  count_of_unique_user_views: number
  count_of_wishlists: number
  email: string
  high_bid: number
  item_id: number
  list_price: number
  resolved: boolean
  sales_target: number
  sales_target_per_carat?: number
  shipping_owner: string
  stock_number: string
  title: string
  user_id: number
  weight?: number
  winning_bid: number
  buy_bid?: number
}

export interface TGeneralActivityMessage {
  message: string
}

export interface TGeneralActivityState {
  loading: boolean
  data: TGeneralActivity[] | null
  errors?: string | undefined
}

export enum ActionTypes {
  GET_GENERAL_ACTIVITY_R = '@@TENDERS/GET_GENERAL_ACTIVITY_R',
  GET_GENERAL_ACTIVITY_S = '@@TENDERS/GET_GENERAL_ACTIVITY_S',
  GET_GENERAL_ACTIVITY_WITH_O_OFFSET_S = '@@TENDERS/GET_GENERAL_ACTIVITY_WITH_O_OFFSET_S',
  GET_GENERAL_ACTIVITY_E = '@@TENDERS/GET_GENERAL_ACTIVITY_E',

  GET_GENERAL_ACTIVITY_CHILD_R = '@@TENDERS/GET_GENERAL_ACTIVITY_CHILD_R',
  GET_GENERAL_ACTIVITY_CHILD_S = '@@TENDERS/GET_GENERAL_ACTIVITY_CHILD_S',
  GET_GENERAL_ACTIVITY_CHILD_E = '@@TENDERS/GET_GENERAL_ACTIVITY_CHILD_E',
}
